import React, {
  useMemo,
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from "react";
import "./ChooseSongs.scss";
import {
  IoCloseCircle,
  IoCloseCircleOutline,
  IoArrowDownOutline,
  IoArrowUpOutline,
  IoSearchOutline
} from "react-icons/io5";
import SelectSongBook from "../UI/SelectSongBook";
import RestClient from "../../../@core/restClient";
import { Song } from "../../../@core/models";
import moment from "moment";
import Spinner from "../../widgets/UI/Spinner";

const ChooseSongs = (props: any, refEdit: any) => {
  const [songList, setSongList]: any = useState(
    props.mainSongbook?.songs || []
  );
  const [selectVisible, setSelectVisible]: any = useState(false);
  const [inputValue, setInputValue]: any = useState("");
  const [bookId, setBookId]: any = useState(null);
  const [isValidTitle, setIsValidTitle] = useState(false);
  const [isValidDate, setIsValidDate] = useState(false);
  const [isValidSong, setIsValidSong] = useState(false);
  const [saveOk, setSaveOk] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidList, setIsValidList] = useState(false);
  const [enteredSongs, setEnteredSongs]: any = useState([]);

  useEffect(() => {
    if (!isValidTitle || !isValidDate || !isValidList) {
      setSaveOk(false);
    } else {
      setSaveOk(true);
    }
  }, [isValidTitle, isValidDate, isValidList]);

  const setVisable = (e: any) => {
    e.stopPropagation();
    setSelectVisible(true);
  };
  useEffect(() => {
    if (selectVisible) {
      document.body.addEventListener("click", () => {
        setSelectVisible(false);
        setInputValue("");
      });
    } else {
      return;
    }
  }, [selectVisible]);

  useEffect(
    function () {
      (async () => {
        if (bookId === null) {
          return;
        }
        try {
          setIsLoading(true);
          const list = await RestClient.getSongList(bookId);
          setSongList(list || []);
        } catch (error) {
          console.log(error);
        }
        setIsLoading(false);
      })();
    },
    [bookId]
  );

  const filteredSongList = useMemo(() => {
    if (inputValue) {
      return songList.filter((song: any) =>
        song.title.toLowerCase().includes(inputValue.toLowerCase())
      );
    } else {
      return songList;
    }
  }, [inputValue, songList]);

  const getBookId = (bookId: any) => {
    setBookId(bookId);
    setIsValidSong(true);
  };

  const [enteredTitle, setEnteredTitle] = useState("");
  const titleChangeHandler = (event: any) => {
    setEnteredTitle(event.target.value);
  };

  const [enteredDate, setEnteredDate] = useState("");
  const dateChangeHandler = (event: any) => {
    setEnteredDate(event.target.value);
  };

  const songChangeHandler = (song: Song) => {
    const lastdates = props.songDates
      .filter((item: any) => item.songs.includes(song.id))
      .sort((a: any, b: any) => moment(b.date).diff(moment(a.date)))
      .slice(0, 3)
      .map((item: any) => moment(item.date).format("DD.MM.YYYY"));

    setSelectVisible(false);
    let sortId = 0;
    let sort = 0;
    enteredSongs.forEach((item: any) => {
      if (item.id > sortId) sortId = item.id;
      if (item.sort > sort) sort = item.sort;
    });
    const songAdded = {
      sortId: ++sortId,
      id: song.id,
      title: song.title,
      date: lastdates,
      sort: sort + 10
    };
    setEnteredSongs([...enteredSongs, songAdded]);
    setInputValue("");
    if (enteredSongs.length === 0) {
      setIsValidList(false);
    } else {
      setIsValidList(true);
    }
  };

  useEffect(() => {
    if (enteredSongs.length === 0) {
      setIsValidList(false);
    } else {
      setIsValidList(true);
    }
    if (bookId || props.mainSongbook) {
      setIsValidSong(true);
    } else {
      setIsValidSong(false);
    }
    if (enteredDate !== "") {
      setIsValidDate(true);
    } else {
      setIsValidDate(false);
    }
    if (enteredTitle !== "") {
      setIsValidTitle(true);
    } else {
      setIsValidTitle(false);
    }
  }, [enteredSongs, enteredDate, enteredTitle]);

  const deleteSong = (song: any) => {
    const newEnteredSongs = enteredSongs.filter((item: any) => item !== song);
    setEnteredSongs(newEnteredSongs);
  };

  const moveSong = (song: any, direction: any) => {
    enteredSongs.forEach((item: any) => {
      if (item.id === song.id) {
        if (direction === "up") item.sort = item.sort - 15;
        if (direction === "down") item.sort = item.sort + 15;
      }
    });
    enteredSongs.sort((a: any, b: any) => {
      return a.sort - b.sort;
    });
    let counter = 0;
    enteredSongs.forEach((item: any) => {
      item.sort = counter + 10;
      counter = counter + 10;
    });
    setEnteredSongs([...enteredSongs]);
  };

  const submitHandler = () => {
    const chosenSongs = {
      //id: props.editedSelection.id,
      groupId: props.selectionGroupId,
      //id: props.selectionGroupId,
      //groupId: props.editedSelection.groupId,
      name: enteredTitle,
      date: moment(enteredDate).format("YYYY-MM-DD"),
      songs: enteredSongs.map((el: any) => el.id),
      sort: enteredSongs.map((el: any) => el.id)
    };

    props.onSavingSongList(chosenSongs);
    setEnteredTitle("");
    setEnteredDate("");
    setEnteredSongs([]);

    props.hideChooseSongsModal();
  };

  useImperativeHandle(refEdit, () => ({
    edit: () => {
      setEnteredTitle(props.editedSelection.name);
      //setEnteredDate(props.editedSelection.date);
      const d = moment(props.editedSelection.date).format("YYYY-MM-DD");
      setEnteredDate(d);
      const songList = props.editedSelection.songs.map((el: any, i: any) => {
        const lastdates = props.songDates
          .filter((item: any) => item.songs.includes(el.id))
          .sort((a: any, b: any) => moment(b.date).diff(moment(a.date)))
          .slice(0, 3)
          .map((item: any) => moment(item.date).format("DD.MM.YYYY"));
        return {
          sortId: i,
          sort: i * 10,
          id: el.id,
          title: el.title,
          date: lastdates
        };
      });
      setEnteredSongs(songList);
      //setEnteredSongs(props.editedSelection.songs);
    }
  }));

  const hideModal = () => {
    props.hideChooseSongsModal();
    setEnteredTitle("");
    setEnteredDate("");
    setEnteredSongs([]);
    setSelectVisible(false);
    setInputValue("");
  };

  return (
    <div>
      <div className="choose">
        {isLoading ? <Spinner /> : ""}
        <div className="choose-input">
          <label>Виберіть збірник</label>
          <SelectSongBook
            passBookId={getBookId}
            mainSongbook={props.mainSongbook}
          />
          <label htmlFor="title">Введіть назву або ведучого</label>
          <input
            type="text"
            name="title"
            id="title"
            className="choose-title"
            value={enteredTitle}
            onChange={titleChangeHandler}
            style={{
              backgroundColor: !isValidTitle ? "rgb(255, 247, 237)" : "#fff"
            }}
          />

          <label htmlFor="date">Виберіть дату</label>
          <input
            type="date"
            name="date"
            id="date"
            className="choose-title"
            value={enteredDate.substring(0, 10)}
            onChange={dateChangeHandler}
            style={{
              backgroundColor: !isValidDate ? "rgb(255, 247, 237)" : "#fff"
            }}
          />

          <label htmlFor="song">Виберіть пісню</label>
          <div className="choose-song">
            <IoSearchOutline className="select-search" />
            <input
              type="text"
              name="song"
              id="song"
              className="choose-title"
              disabled={!isValidSong}
              value={inputValue}
              style={{
                backgroundColor: !isValidSong ? "rgb(255, 247, 237)" : "#fff"
              }}
              onChange={(e) => setInputValue(e.target.value)}
              onClick={(e) => setVisable(e)}
            />

            <div className={`songSelection ${selectVisible ? "visable" : ""}`}>
              {filteredSongList.map((song: any) => (
                <div
                  key={song.id}
                  className="select-box-item"
                  onClick={() => songChangeHandler(song)}
                >
                  {song.title}
                </div>
              ))}
              <IoCloseCircleOutline
                className="select-close"
                onClick={() => {
                  setSelectVisible(false);
                  setInputValue("");
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <ol className="chosen-songs">
            {enteredSongs.map((el: any, i: any) => (
              <li key={i}>
                <div className="chosen-songs-items">
                  <div className="chosen-songs-item">
                    <p>{el.title}</p>

                    <div className="chosen-songs-icons">
                      <IoArrowUpOutline
                        className="icon"
                        onClick={() => moveSong(el, "up")}
                      />
                      <IoArrowDownOutline
                        className="icon"
                        onClick={() => moveSong(el, "down")}
                      />
                      <IoCloseCircle
                        className="icon"
                        onClick={() => deleteSong(el)}
                      />
                    </div>
                  </div>
                  <div className="lastDate">
                    <p>Останнє виконання - </p>
                    {el.date?.map((d: any, i: any) => (
                      <p key={i}>{d};</p>
                    ))}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
        <div className="choose-btns">
          <button
            className={saveOk ? "btn-mcolor" : "btn-mcolor-inactive"}
            disabled={saveOk ? false : true}
            onClick={submitHandler}
          >
            Зберегти
          </button>
          <button className="btn-plain" onClick={hideModal}>
            Скасувати
          </button>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(ChooseSongs);
